import React, {memo} from "react";
import SingleCard from "./SingleCard";

const CardsList = ({
  data,
  dragToggle,
  addButtonStateChange,
  onDragStart,
  onDrop,
  onDragOver,
  onDragEnter,
  onDragEnd,
  inputsInnerWrapperRef,
  dragInnerItem,
  dropInnerItem,
  allowDropInnerItem,
  leaveDropInner,
  onInputChange,
  deleteSection,
  renderSelectedItem,
  addSubSection,
  addOption,
}) => {
  return (
    <>
      {data.map((item, index) => (
        <SingleCard
          data={item}
          index={index}
          dragToggle={dragToggle}
          onInputChange={onInputChange}
          addButtonStateChange={addButtonStateChange}
          onDragStart={onDragStart}
          onDrop={onDrop}
          onDragOver={onDragOver}
          onDragEnd={onDragEnd}
          onDragEnter={onDragEnter}
          inputsInnerWrapperRef={inputsInnerWrapperRef}
          dragInnerItem={dragInnerItem}
          dropInnerItem={dropInnerItem}
          allowDropInnerItem={allowDropInnerItem}
          leaveDropInner={leaveDropInner}
          deleteSection={deleteSection}
          renderSelectedItem={renderSelectedItem}
          addOption={addOption}
          addSubSection={addSubSection}
        />
      ))}
    </>
  );
};

export default CardsList;
